import { Button } from '@cropler/ui-kit';

import styles from './styles.module.scss';
import { Icon as CroplerIcon } from '@cropler/ui-kit';

const SidebarItemNavigator = ({ onClickButton, isButtonLarge }) => {
  return (
    <Button
      className={styles.sidebarItemNavigator}
      type={'text'}
      icon={<CroplerIcon name="navigator" />}
      size={isButtonLarge ? 'large' : ''}
      onClick={onClickButton}
    />
  );
};

export default SidebarItemNavigator;
